module.exports = __webpack_public_path__ + "assets/img/open_2.e42d8a6a.png";